import graphqlClient from "@/GQLClient";
import {
  type CoreNewsAuthorFragment,
  type CoreNewsAsAdminItemFragment,
  type CoreNewsItemFragment,
} from "@/graphql";
import {
  GetCoreNewsAsAdminDocument,
  GetCoreNewsAuthorsDocument,
  GetCoreNewsDocument,
  MarkReadDocument,
  SaveCoreNewsDocument,
  type CoreNewsInput,
} from "@/graphql/generated-types";
import type { FetchPolicy } from "@apollo/client";
import { GraphQLError } from "graphql";

const getCoreNewsAsAdmin = async (
  fetchPolicy: FetchPolicy = "no-cache",
): Promise<CoreNewsAsAdminItemFragment[]> => {
  const response = await graphqlClient.query({
    query: GetCoreNewsAsAdminDocument,
    fetchPolicy,
  });

  if (response.data?.coreNews?.getAsAdmin) {
    return response.data?.coreNews?.getAsAdmin as CoreNewsAsAdminItemFragment[];
  }

  throw new GraphQLError(`api.coreNews.getCoreNews`);
};

const getCoreNews = async (): Promise<CoreNewsItemFragment[]> => {
  const response = await graphqlClient.query({
    query: GetCoreNewsDocument,
    fetchPolicy: "network-only",
  });

  if (response.data?.coreNews?.get) {
    return response.data?.coreNews?.get as CoreNewsItemFragment[];
  }

  throw new GraphQLError(`api.coreNews.getCoreNews`);
};

const getCoreNewsAsEmployee = async (
  fetchPolicy: FetchPolicy = "no-cache",
): Promise<CoreNewsItemFragment[]> => {
  const response = await graphqlClient.query({
    query: GetCoreNewsDocument,
    fetchPolicy,
  });

  if (response.data?.coreNews?.get) {
    return response.data?.coreNews?.get as CoreNewsItemFragment[];
  }

  throw new GraphQLError(`api.coreNews.getCoreNews`);
};

const getAuthors = async (
  fetchPolicy: FetchPolicy = "no-cache",
): Promise<CoreNewsAuthorFragment[]> => {
  const response = await graphqlClient.query({
    query: GetCoreNewsAuthorsDocument,
    fetchPolicy,
  });

  if (response.data?.coreNews?.getAuthors) {
    return response.data?.coreNews.getAuthors as CoreNewsAuthorFragment[];
  }

  throw new GraphQLError(`api.coreNews.getAuthors`);
};

const save = async (coreNews: CoreNewsInput) => {
  const response = await graphqlClient.query({
    query: SaveCoreNewsDocument,
    variables: {
      coreNews,
    },
    fetchPolicy: "no-cache",
  });

  if (response.data.coreNews?.save?.success) {
    return response;
  }

  throw new GraphQLError(`api.coreNews.saveCoreNews`);
};

const markRead = async (id: string) => {
  const response = await graphqlClient.query({
    query: MarkReadDocument,
    variables: {
      id: id,
      isRead: true,
    },
    fetchPolicy: "no-cache",
  });

  if (response.data.coreNews?.markRead?.success) {
    return response;
  }

  throw new GraphQLError(`api.coreNews.saveCoreNews`);
};

export default {
  getCoreNewsAsAdmin,
  getCoreNews,
  getCoreNewsAsEmployee,
  getAuthors,
  save,
  markRead,
};
